import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacabsonrentinpune() {



const cardData = {
  keyword: "Innova Cabs on Rent in Pune",
  heading: "Lotus Cab: Innova Cabs on Rent in Pune",

  headingDescription:
    "Lotus Cab offers premium Toyota Innova Cabs on rent in Pune for airport transfers, corporate travel, weddings, family vacations, and long-distance outstation journeys. The Toyota Innova is one of the most trusted MPVs in India, known for its powerful engine performance, smooth suspension, spacious 7-seater comfort, and excellent highway stability. Whether you are planning a local city ride or an interstate road trip, our AC Innova taxis ensure a comfortable and safe journey. All vehicles are regularly serviced, fully sanitized, and driven by professional, background-verified chauffeurs who understand city routes and highway driving standards. We provide transparent per-kilometer pricing with flexible one-way, round-trip, and hourly rental packages. With punctual pickup, 24/7 customer support, and easy online booking, Lotus Cab ensures your Innova rental experience in Pune is smooth, reliable, and completely hassle-free.",

  top: "Top Places to Visit in Pune with Innova Cab",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks built during the Peshwa dynasty. The grand architecture and massive fort walls reflect the rich Maratha heritage. Families, corporate guests, and tourists frequently include this destination in their Pune sightseeing itinerary. The spacious Innova cab ensures comfortable group travel within city limits. Its smooth suspension makes city driving stress-free. Lotus Cab provides timely pickup and flexible waiting options for sightseeing trips."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a historic hill fort located near Pune and is famous for its connection to Chhatrapati Shivaji Maharaj. The scenic drive towards the fort requires a stable and powerful vehicle like Toyota Innova. Ideal for weekend family outings and corporate team trips. The SUV-like stability of Innova ensures safe uphill travel. Comfortable AC seating makes long drives enjoyable. Lotus Cab guarantees experienced drivers for hilly terrain."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is an important historical monument linked to India’s freedom movement. The palace attracts tourists, school groups, and corporate visitors. Its serene gardens and museum displays offer a peaceful experience. Innova rental provides spacious seating for family tours. Smooth city navigation makes travel convenient. Lotus Cab offers reliable local taxi support."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description:
        "This temple is one of Pune’s most visited spiritual landmarks. Devotees from across Maharashtra visit for blessings. Comfortable city travel is essential during busy hours. The Innova taxi ensures smooth temple visits. AC comfort keeps travel relaxed in all seasons."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a scenic hill city near Pune popular for corporate outings and family trips. The highway route is ideal for Innova MPV travel. The vehicle’s smooth suspension enhances long-distance comfort. Ideal for weekend tours."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a favorite weekend getaway near Pune. The Mumbai–Pune Expressway route is perfect for Innova performance. Spacious interiors ensure relaxed family travel."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a popular hill station requiring comfortable highway travel. Innova cab provides stable long-distance ride."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "A popular picnic spot near Pune. Families prefer comfortable SUV-like travel. Innova ensures smooth round-trip convenience."
    }
  ],

  services: [
    {
      name: "Toyota Innova Cab on Rent in Pune",
      description:
        "Premium Toyota Innova cab rental in Pune offering spacious 7-seater comfort for family, corporate, and outstation travel. The vehicle features powerful engine performance, smooth suspension, and AC interiors for long-distance convenience. Ideal for airport transfers, weddings, and executive trips. Professional chauffeur included with every booking. Transparent per-km pricing with flexible packages available."
    },
    {
      name: "Innova Taxi Pune",
      description:
        "Reliable Innova taxi service in Pune for city rides and long highway journeys. Comfortable seating for up to seven passengers. AC vehicle maintained to high hygiene standards. Experienced drivers ensure safe navigation through city traffic. Perfect for business and personal travel needs."
    },
    {
      name: "Innova for Outstation Pune",
      description:
        "Comfortable outstation Innova cab from Pune to major cities like Mumbai, Nashik, Shirdi, Goa, and Bangalore. Long-distance highway stability ensures smooth travel. Spacious luggage support available. Ideal for family tours and corporate trips."
    },
    {
      name: "Innova Airport Cab Pune",
      description:
        "Timely airport pickup and drop service with Toyota Innova cab. Spacious seating and luggage capacity ensure comfortable airport transfers. Professional driver tracks flight timing. Safe and punctual travel guaranteed."
    },
    {
      name: "Affordable Innova Cab Pune",
      description:
        "Budget-friendly Innova rental with transparent pricing and no hidden charges. Ideal for daily travel, family outings, and business meetings. Flexible one-way and round-trip packages available."
    },
    {
      name: "Innova Corporate Cab Pune",
      description:
        "Professional Innova cab service for corporate clients and business executives. Clean vehicles and uniformed chauffeurs provided. Monthly billing options available."
    },
    {
      name: "Chauffeur Driven Innova Pune",
      description:
        "Experienced and background-verified drivers assigned for every booking. Safe and professional travel experience ensured."
    },
    {
      name: "Online Innova Booking Pune",
      description:
        "Instant online booking available with quick confirmation and 24/7 customer support."
    }
  ],

  tableData: [
    ["Innova Cabs on Rent in Pune", "Toyota Innova Cab on Rent in Pune"],
    ["Innova Taxi Pune", "Innova for Outstation Pune"],
    ["Innova Airport Cab Pune", "Innova Per Km Rate Pune"],
    ["Affordable Innova Cab Pune", "Innova for Family Trip Pune"],
    ["Innova Corporate Cab Pune", "AC Innova Taxi Pune"],
    ["7 Seater Innova Rental Pune", "Chauffeur Driven Innova Pune"],
    ["Innova Drop Service Pune", "Luxury MPV Pune"],
    ["Online Innova Booking Pune", "Best Innova Service Pune"],
    ["SUV Rental Pune", ""]
  ],

  whychoose: [
    { WhyChooseheading: "Spacious 7 Seater Comfort", WhyChoosedescription: "Ample legroom and luggage space for family and group travel with AC interiors." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Experienced drivers trained for city and highway routes ensuring safety." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-km rate with no hidden costs." },
    { WhyChooseheading: "Reliable Airport Transfers", WhyChoosedescription: "On-time pickup and drop service guaranteed." },
    { WhyChooseheading: "Corporate Travel Support", WhyChoosedescription: "Executive-level travel solutions for businesses." },
    { WhyChooseheading: "Well-Maintained Vehicles", WhyChoosedescription: "Regular servicing and sanitization maintained." },
    { WhyChooseheading: "Flexible Trip Options", WhyChoosedescription: "One-way, round-trip, and hourly packages available." },
    { WhyChooseheading: "24/7 Booking Assistance", WhyChoosedescription: "Round-the-clock support for hassle-free booking." }
  ]
};

const faqData = [
  { question: "Do you provide 7 seater Innova?", answer: "Yes, spacious 7-seater Innova available for rent in Pune." },
  { question: "Is driver included?", answer: "Yes, professional chauffeur included with booking." },
  { question: "Is airport transfer available?", answer: "Yes, Pune airport pickup and drop service provided." },
  { question: "Is per km rate transparent?", answer: "Yes, clear per-km pricing without hidden charges." },
  { question: "Is outstation travel supported?", answer: "Yes, long-distance outstation cab service available." },
  { question: "Is online booking possible?", answer: "Yes, instant online booking available." },
  { question: "Are vehicles AC?", answer: "Yes, all Innova cabs are air-conditioned." },
  { question: "Are vehicles sanitized?", answer: "Yes, regularly cleaned and sanitized." },
  { question: "Do you provide corporate service?", answer: "Yes, dedicated corporate cab solutions available." },
  { question: "Is round trip available?", answer: "Yes, flexible round-trip packages offered." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "Booked Innova for family outstation trip. Very comfortable seating and smooth ride. Professional driver and fair pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Executive",
    feedback:
      "Used Innova for airport transfer. Timely pickup and clean vehicle. Highly reliable service.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Neha Patil",
    feedback:
      "Affordable Innova rental with excellent customer support. Perfect for family travel.",
    rating: 5
  }
];








































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cabs on Rent in Pune",
  "image": "https://lotuscab.com/assets/images/innova-cabs-rent-pune.jpg", 
  "description": "Lotus Cab offers Toyota Innova cabs on rent in Pune for outstation trips, airport transfers, corporate travel, and family trips. 7-seater AC SUVs with chauffeur service, affordable per km rates, luxury MPV options, and convenient online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/innova-cabs-on-rent-pune"
  }
};










  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Innova Cabs on Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Toyota Innova cabs in Pune with Lotus Cab. 7-seater AC SUV for outstation, airport, corporate, and family trips. Chauffeur included. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Toyota Innova Cab on Rent in Pune, Innova Taxi Pune, Innova for Outstation Pune, Innova Airport Cab Pune, Innova Per Km Rate Pune, Affordable Innova Cab Pune, Innova for Family Trip Pune, Innova Corporate Cab Pune, AC Innova Taxi Pune, 7 Seater Innova Rental Pune, Chauffeur Driven Innova Pune, Innova Drop Service Pune, Luxury MPV Pune, Online Innova Booking Pune, Best Innova Service Pune, SUV Rental Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacabsonrentinpune;